// THis link may help: https://www.softkraft.co/how-to-setup-redux-with-redux-toolkit/
import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import user from './reducers/user';

const reducer = combineReducers({
    user
})
const store = configureStore({
  reducer,
})
export default store;